(function () {
    'use strict';

    /**
    * @memberof app
    * @ngdoc controller
    * @name BlogController
    * @description
    * This is main controller
    **/

    angular
        .module('app')
        .controller('BlogController', BlogController);

    BlogController.$inject = ["$scope", "BlogService", "$timeout", "$element", "$document"];

    function BlogController($scope, BlogService, $timeout, $element, $document) {

        var vm = this;
        vm.filtros = {};
        vm.categoria_blog = "";
        $scope.categoria_blog = vm.filtros.categoria_blog;
        vm.numPaginas = 0;
        vm.page = 0;

        vm.showBlogs = function (init) {
            BlogService.getBlogs(vm.filtros, vm).then(function (data) {
                vm.blogs = data.blogs;
                vm.categoriasblog = data.categoriasblog;
                vm.numPaginas = data.numPaginas;
                // vm.elementos = angular.element(document.querySelectorAll('.container'));
                setTimeout(function(){
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                })
            });
        }

        vm.next = function () {
            vm.page++;
            vm.showBlogs();
        };

        vm.prev = function () {
            vm.page--;
            vm.showBlogs();
        };

        vm.resetFilters = function () {
            $timeout(function () {
                vm.filtros.categoria_blog = {};
                $scope.categoria_blog = vm.filtros.categoria_blog;
                vm.filtros.categoria_blog["todos"] = true;
            });

        }

        $scope.$watch("categoria_blog", function (newValue, oldValue) {
            //console.log(newValue);
            var b = false;
            angular.forEach(newValue, function (item) {
                if (item) {
                    b = true;
                }
            });
            if (!b)
                vm.resetFilters();

            return true;

        }, true);
    }

})();